import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapState } from 'vuex';
import { Navbar, Sidebar, AppMain, HeadBar } from './components';
import ResizeMixin from './mixin/ResizeHandler';
import Hamburger from '@/components/Hamburger';
export default {
  name: 'Layout',
  components: {
    Navbar: Navbar,
    Sidebar: Sidebar,
    AppMain: AppMain,
    HeadBar: HeadBar,
    Hamburger: Hamburger
  },
  data: function data() {
    return {
      leftWith: '0px',
      isThemeAdded: false
    };
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.name) {
        this.$store.commit('app/SET_MENUID', to.name);
      }
    },
    userTheme: {
      handler: function handler(n, o) {
        this.handleThemeChange(n);
      }
    }
  },
  mixins: [ResizeMixin],
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters(['sidebar', 'avatar'])), mapState({
    isShowSidebar: function isShowSidebar(state) {
      return state.app.isShowSidebar;
    },
    userTheme: function userTheme(state) {
      return state.user.userTheme;
    }
  })), {}, {
    isZqpt: function isZqpt() {
      return this.$store.state.user.userType === 8;
    },
    sidebar: function sidebar() {
      return this.$store.state.app.sidebar;
    },
    device: function device() {
      return this.$store.state.app.device;
    },
    fixedHeader: function fixedHeader() {
      return this.$store.state.settings.fixedHeader;
    },
    classObj: function classObj() {
      return {
        hideSidebar: false,
        // 修改侧边栏是否隐藏为必定不隐藏
        openSidebar: true,
        withoutAnimation: false,
        // hideSidebar: !this.sidebar.opened,
        // openSidebar: this.sidebar.opened,
        // withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      };
    }
  }),
  created: function created() {
    if (this.$route.name) {
      this.$store.commit('app/SET_MENUID', this.$route.name);
    }

    this.handleThemeChange(this.userTheme);
  },
  methods: (_methods = {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    handleClickOutside: function handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', {
        withoutAnimation: false
      });
    },
    changeMainStyle: function changeMainStyle(reload) {
      var container = document.querySelector('.main-container');
      this.$store.commit('app/CHANGE_SIDEBAR', reload);

      if (reload) {
        container.style.marginLeft = '240px';
      } else {
        container.style.marginLeft = '0px';
      }
    },
    setNavyBlueTheme: function setNavyBlueTheme() {
      var style = document.createElement('link');
      style.href = '/web/static/theme/navyBlue/index.css';
      style.rel = 'stylesheet';
      style.id = 'navyBlue';
      style.type = 'text/css';
      document.getElementsByTagName('HEAD').item(0).appendChild(style);
    },
    handleThemeChange: function handleThemeChange(theme) {
      var _this = this;

      // 切换主题
      this.isThemeAdded = false;
      this.$nextTick(function () {
        // const dropdownMenus = document.querySelectorAll('.dropdow-menu-theme .el-dropdown-menu__item')
        // if (theme || this.isZqpt) {
        //     if(!this.isZqpt) {
        //         dropdownMenus[0].style.backgroundColor = ''
        //         dropdownMenus[0].style.color = ''
        //         dropdownMenus[1].style.backgroundColor = '#e9f0f8'
        //         dropdownMenus[1].style.color = '#5287c4'
        //     }
        //     this.setNavyBlueTheme()
        // } else {
        //     if(!this.isZqpt) {
        //         dropdownMenus[0].style.backgroundColor = '#ebf9f6'
        //         dropdownMenus[0].style.color = '#61d1b9'
        //         dropdownMenus[1].style.backgroundColor = ''
        //         dropdownMenus[1].style.color = ''
        //     }
        //     this.removeNavyBlueTheme()
        // }
        setTimeout(function () {
          _this.isThemeAdded = true;
        }, 650);
      });
    }
  }, _defineProperty(_methods, "setNavyBlueTheme", function setNavyBlueTheme() {
    var style = document.createElement('link');
    style.href = '/web/static/theme/navyBlue/index.css';
    style.rel = 'stylesheet';
    style.id = 'navyBlue';
    style.type = 'text/css';
    document.getElementsByTagName('HEAD').item(0).appendChild(style);
  }), _defineProperty(_methods, "removeNavyBlueTheme", function removeNavyBlueTheme() {
    var cssLink = document.querySelectorAll('#navyBlue');

    if (cssLink && cssLink.length > 0) {
      cssLink.forEach(function (childNode) {
        childNode.parentNode.removeChild(childNode);
      });
    }
  }), _methods)
};